import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Picture, Button } from '@bwoty-web/styleguide';
import MatchingBadges from '../matchingBadges/matchingBadges';
import CardLink from '../cardLink/cardLink';
import { getCloudinarySources } from '../../../utils/imageUtils';
import { createAnchor } from '../../../utils/helpers';
import './articleCard.scss';

const ArticleCard = ({
  imageDomain,
  imageRelativeUrl,
  header,
  subHeader,
  description,
  quoteAuthor,
  url,
  itemClassifications,
  labels,
  trackingProduct,
  filters,
  classifications,
}) => {
  const getImage = () => {
    const checkedImageRelativeUrl =
      imageRelativeUrl || labels.fallbackArticleImage;
    return (
      <Picture
        lazy
        className="vf-result-concept-card__image"
        alt={header}
        sources={[
          ...getCloudinarySources(
            '(max-width: 470px)',
            imageDomain,
            checkedImageRelativeUrl,
            375,
            472,
          ),
          ...getCloudinarySources(
            'min-width: 471) and (max-width: 767px)',
            imageDomain,
            checkedImageRelativeUrl,
            527,
            791,
          ),
          ...getCloudinarySources(
            '(min-width: 768px)',
            imageDomain,
            checkedImageRelativeUrl,
            375,
            472,
          ),
        ]}
      />
    );
  };

  return (
    <div
      id={createAnchor(header)}
      className="vf-result-card vf-result-concept-card"
    >
      <div className="vf-result-concept-card__info-container">
        <div className="vf-result-concept-card__header-container">
          <h2 className="vf-result-concept-card__header">{header}</h2>
          {subHeader && (
            <h3 className="vf-result-concept-card__sub-header">{subHeader}</h3>
          )}
        </div>
        <p className="vf-result-concept-card__description">{description}</p>
        {quoteAuthor && (
          <p className="vf-result-concept-card__quote-author">{quoteAuthor}</p>
        )}

        <CardLink
          anchorName={header}
          url={url}
          trackingProduct={trackingProduct}
        >
          <Button
            theme="primary"
            className="vf-result-concept-card__primary-button"
            href={url}
          >
            {labels.buttonText}
          </Button>
        </CardLink>
      </div>

      <div className="vf-result-concept-card__image-container">
        <CardLink
          anchorName={header}
          url={url}
          trackingProduct={trackingProduct}
        >
          {getImage()}
        </CardLink>
        <MatchingBadges itemClassifications={itemClassifications} filters={filters} classifications={classifications} />
      </div>
    </div>
  );
};

ArticleCard.defaultProps = {
  subHeader: '',
  quoteAuthor: '',
};

ArticleCard.propTypes = {
  imageDomain: PropTypes.string.isRequired,
  imageRelativeUrl: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string,
  itemClassifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  quoteAuthor: PropTypes.string,
  labels: PropTypes.shape({
    buttonText: PropTypes.string.isRequired,
    fallbackArticleImage: PropTypes.string.isRequired,
  }).isRequired,
  trackingProduct: PropTypes.shape({}).isRequired,
};

const mapStateToProps = ({ siteSettings }) => ({
  filters: siteSettings.filters,
  classifications: siteSettings.classifications,
});

const memoizedArticleCard = React.memo(ArticleCard, (prevProps, newProps) => {
  return prevProps.objectID === newProps.objectID;
})

export default connect(mapStateToProps)(memoizedArticleCard);
